export default __webpack_public_path__ + "static/media/Z_Forms.53768968.png";